// source: livongo/protobuf/grpc/external/food/food.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var livongo_protobuf_common_meta_image_pb = require('../../../../../livongo/protobuf/common/meta/image_pb.js');
goog.object.extend(proto, livongo_protobuf_common_meta_image_pb);
var livongo_protobuf_common_types_absoluteTimestamp_pb = require('../../../../../livongo/protobuf/common/types/absoluteTimestamp_pb.js');
goog.object.extend(proto, livongo_protobuf_common_types_absoluteTimestamp_pb);
var teladoc_protobuf_common_user_identity_userId_pb = require('../../../../../teladoc/protobuf/common/user/identity/userId_pb.js');
goog.object.extend(proto, teladoc_protobuf_common_user_identity_userId_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_field_mask_pb = require('google-protobuf/google/protobuf/field_mask_pb.js');
goog.object.extend(proto, google_protobuf_field_mask_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.OptFoodLogCase', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.FoodLog', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.FoodLogs', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.FoodType', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.FoodType.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.Meal', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.MealTag', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.MealTag.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.NixFood', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.RecentFood', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.oneofGroups_);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming.displayName = 'proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.food.FoodLogs.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.FoodLogs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.FoodLogs.displayName = 'proto.com.livongo.protobuf.grpc.external.food.FoodLogs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.FoodLog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.FoodLog.displayName = 'proto.com.livongo.protobuf.grpc.external.food.FoodLog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.MealTag = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.MealTag, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.MealTag.displayName = 'proto.com.livongo.protobuf.grpc.external.food.MealTag';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.NixFood, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.NixFood.displayName = 'proto.com.livongo.protobuf.grpc.external.food.NixFood';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.FoodType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.FoodType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.FoodType.displayName = 'proto.com.livongo.protobuf.grpc.external.food.FoodType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields.displayName = 'proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.displayName = 'proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields.displayName = 'proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields.displayName = 'proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.RecentFood = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.RecentFood, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.RecentFood.displayName = 'proto.com.livongo.protobuf.grpc.external.food.RecentFood';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse.displayName = 'proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility.displayName = 'proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields.displayName = 'proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus.displayName = 'proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.Meal = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.food.Meal.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.Meal, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.Meal.displayName = 'proto.com.livongo.protobuf.grpc.external.food.Meal';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse.displayName = 'proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.OptFoodLogCase = {
  OPT_FOOD_LOG_NOT_SET: 0,
  IMAGE_BYTE: 1,
  FOOD_LOG_CREATION: 2
};

/**
 * @return {proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.OptFoodLogCase}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.prototype.getOptFoodLogCase = function() {
  return /** @type {proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.OptFoodLogCase} */(jspb.Message.computeOneofCase(this, proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    imageByte: msg.getImageByte_asB64(),
    foodLogCreation: (f = msg.getFoodLogCreation()) && proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest;
  return proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setImageByte(value);
      break;
    case 2:
      var value = new proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.deserializeBinaryFromReader);
      msg.setFoodLogCreation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getFoodLogCreation();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.serializeBinaryToWriter
    );
  }
};


/**
 * optional bytes image_byte = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.prototype.getImageByte = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes image_byte = 1;
 * This is a type-conversion wrapper around `getImageByte()`
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.prototype.getImageByte_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getImageByte()));
};


/**
 * optional bytes image_byte = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getImageByte()`
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.prototype.getImageByte_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getImageByte()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.prototype.setImageByte = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.prototype.clearImageByte = function() {
  return jspb.Message.setOneofField(this, 1, proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.prototype.hasImageByte = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FoodLogCreation food_log_creation = 2;
 * @return {?proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.prototype.getFoodLogCreation = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation, 2));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.prototype.setFoodLogCreation = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.prototype.clearFoodLogCreation = function() {
  return this.setFoodLogCreation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequest.prototype.hasFoodLogCreation = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming.toObject = function(includeInstance, msg) {
  var f, obj = {
    foodLogCreation: (f = msg.getFoodLogCreation()) && proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.toObject(includeInstance, f),
    imageByte: msg.getImageByte_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming;
  return proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.deserializeBinaryFromReader);
      msg.setFoodLogCreation(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setImageByte(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFoodLogCreation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.serializeBinaryToWriter
    );
  }
  f = message.getImageByte_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional FoodLogCreation food_log_creation = 1;
 * @return {?proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming.prototype.getFoodLogCreation = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation, 1));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming.prototype.setFoodLogCreation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming.prototype.clearFoodLogCreation = function() {
  return this.setFoodLogCreation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming.prototype.hasFoodLogCreation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes image_byte = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming.prototype.getImageByte = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes image_byte = 2;
 * This is a type-conversion wrapper around `getImageByte()`
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming.prototype.getImageByte_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getImageByte()));
};


/**
 * optional bytes image_byte = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getImageByte()`
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming.prototype.getImageByte_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getImageByte()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.CreateFoodLogRequestNonStreaming.prototype.setImageByte = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogs.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogs.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogs.toObject = function(includeInstance, msg) {
  var f, obj = {
    foodLogList: jspb.Message.toObjectList(msg.getFoodLogList(),
    proto.com.livongo.protobuf.grpc.external.food.FoodLog.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogs}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.FoodLogs;
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogs}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.livongo.protobuf.grpc.external.food.FoodLog;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.FoodLog.deserializeBinaryFromReader);
      msg.addFoodLog(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.FoodLogs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFoodLogList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.livongo.protobuf.grpc.external.food.FoodLog.serializeBinaryToWriter
    );
  }
};


/**
 * repeated FoodLog food_log = 1;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLog>}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogs.prototype.getFoodLogList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.FoodLog, 1));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLog>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogs} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogs.prototype.setFoodLogList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogs.prototype.addFoodLog = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.livongo.protobuf.grpc.external.food.FoodLog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogs} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogs.prototype.clearFoodLogList = function() {
  return this.setFoodLogList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.FoodLog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    imageMeta: (f = msg.getImageMeta()) && livongo_protobuf_common_meta_image_pb.ImageMetadata.toObject(includeInstance, f),
    note: jspb.Message.getFieldWithDefault(msg, 3, ""),
    imageUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
    mealTag: jspb.Message.getFieldWithDefault(msg, 5, 0),
    id: jspb.Message.getFieldWithDefault(msg, 6, 0),
    uploadTime: (f = msg.getUploadTime()) && livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.toObject(includeInstance, f),
    updateTime: (f = msg.getUpdateTime()) && livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.toObject(includeInstance, f),
    deleteTime: (f = msg.getDeleteTime()) && livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.toObject(includeInstance, f),
    createTime: (f = msg.getCreateTime()) && livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.toObject(includeInstance, f),
    nixFood: (f = msg.getNixFood()) && proto.com.livongo.protobuf.grpc.external.food.NixFood.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.FoodLog;
  return proto.com.livongo.protobuf.grpc.external.food.FoodLog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new livongo_protobuf_common_meta_image_pb.ImageMetadata;
      reader.readMessage(value,livongo_protobuf_common_meta_image_pb.ImageMetadata.deserializeBinaryFromReader);
      msg.setImageMeta(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    case 5:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.food.MealTag.Values} */ (reader.readEnum());
      msg.setMealTag(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 7:
      var value = new livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp;
      reader.readMessage(value,livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.deserializeBinaryFromReader);
      msg.setUploadTime(value);
      break;
    case 8:
      var value = new livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp;
      reader.readMessage(value,livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    case 9:
      var value = new livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp;
      reader.readMessage(value,livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.deserializeBinaryFromReader);
      msg.setDeleteTime(value);
      break;
    case 10:
      var value = new livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp;
      reader.readMessage(value,livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.deserializeBinaryFromReader);
      msg.setCreateTime(value);
      break;
    case 11:
      var value = new proto.com.livongo.protobuf.grpc.external.food.NixFood;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.NixFood.deserializeBinaryFromReader);
      msg.setNixFood(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.FoodLog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getImageMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      livongo_protobuf_common_meta_image_pb.ImageMetadata.serializeBinaryToWriter
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMealTag();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getUploadTime();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.serializeBinaryToWriter
    );
  }
  f = message.getDeleteTime();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreateTime();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.serializeBinaryToWriter
    );
  }
  f = message.getNixFood();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.com.livongo.protobuf.grpc.external.food.NixFood.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional com.livongo.protobuf.common.meta.ImageMetadata image_meta = 2;
 * @return {?proto.com.livongo.protobuf.common.meta.ImageMetadata}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.getImageMeta = function() {
  return /** @type{?proto.com.livongo.protobuf.common.meta.ImageMetadata} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_meta_image_pb.ImageMetadata, 2));
};


/**
 * @param {?proto.com.livongo.protobuf.common.meta.ImageMetadata|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.setImageMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.clearImageMeta = function() {
  return this.setImageMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.hasImageMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string note = 3;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string image_url = 4;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional MealTag.Values meal_tag = 5;
 * @return {!proto.com.livongo.protobuf.grpc.external.food.MealTag.Values}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.getMealTag = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.food.MealTag.Values} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.MealTag.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.setMealTag = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int32 id = 6;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional com.livongo.protobuf.common.types.AbsoluteTimestamp upload_time = 7;
 * @return {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.getUploadTime = function() {
  return /** @type{?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp, 7));
};


/**
 * @param {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.setUploadTime = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.clearUploadTime = function() {
  return this.setUploadTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.hasUploadTime = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional com.livongo.protobuf.common.types.AbsoluteTimestamp update_time = 8;
 * @return {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.getUpdateTime = function() {
  return /** @type{?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp, 8));
};


/**
 * @param {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional com.livongo.protobuf.common.types.AbsoluteTimestamp delete_time = 9;
 * @return {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.getDeleteTime = function() {
  return /** @type{?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp, 9));
};


/**
 * @param {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.setDeleteTime = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.clearDeleteTime = function() {
  return this.setDeleteTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.hasDeleteTime = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional com.livongo.protobuf.common.types.AbsoluteTimestamp create_time = 10;
 * @return {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.getCreateTime = function() {
  return /** @type{?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp, 10));
};


/**
 * @param {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.setCreateTime = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.clearCreateTime = function() {
  return this.setCreateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.hasCreateTime = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional NixFood nix_food = 11;
 * @return {?proto.com.livongo.protobuf.grpc.external.food.NixFood}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.getNixFood = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.food.NixFood} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.NixFood, 11));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.food.NixFood|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.setNixFood = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLog} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.clearNixFood = function() {
  return this.setNixFood(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLog.prototype.hasNixFood = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.MealTag.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.MealTag.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.MealTag} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.MealTag.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.MealTag}
 */
proto.com.livongo.protobuf.grpc.external.food.MealTag.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.MealTag;
  return proto.com.livongo.protobuf.grpc.external.food.MealTag.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.MealTag} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.MealTag}
 */
proto.com.livongo.protobuf.grpc.external.food.MealTag.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.MealTag.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.MealTag.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.MealTag} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.MealTag.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.food.MealTag.Values = {
  INVALID: 0,
  BREAKFAST: 1,
  LUNCH: 2,
  DINNER: 3,
  SNACK: 4
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.NixFood.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.NixFood} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.toObject = function(includeInstance, msg) {
  var f, obj = {
    foodId: (f = msg.getFoodId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    foodName: (f = msg.getFoodName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    foodType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    portionQuantity: (f = msg.getPortionQuantity()) && google_protobuf_wrappers_pb.FloatValue.toObject(includeInstance, f),
    portionUnit: (f = msg.getPortionUnit()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    nutritionixId: (f = msg.getNutritionixId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    calCount: (f = msg.getCalCount()) && google_protobuf_wrappers_pb.FloatValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.NixFood}
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.NixFood;
  return proto.com.livongo.protobuf.grpc.external.food.NixFood.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.NixFood} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.NixFood}
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setFoodId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setFoodName(value);
      break;
    case 3:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.food.FoodType.Values} */ (reader.readEnum());
      msg.setFoodType(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.FloatValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.FloatValue.deserializeBinaryFromReader);
      msg.setPortionQuantity(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPortionUnit(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setNutritionixId(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.FloatValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.FloatValue.deserializeBinaryFromReader);
      msg.setCalCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.NixFood.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.NixFood} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFoodId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getFoodName();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getFoodType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPortionQuantity();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.FloatValue.serializeBinaryToWriter
    );
  }
  f = message.getPortionUnit();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getNutritionixId();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCalCount();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.FloatValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Int32Value food_id = 1;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.getFoodId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 1));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.NixFood} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.setFoodId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.NixFood} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.clearFoodId = function() {
  return this.setFoodId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.hasFoodId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue food_name = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.getFoodName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.NixFood} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.setFoodName = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.NixFood} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.clearFoodName = function() {
  return this.setFoodName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.hasFoodName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional FoodType.Values food_type = 3;
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodType.Values}
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.getFoodType = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.food.FoodType.Values} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodType.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.NixFood} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.setFoodType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional google.protobuf.FloatValue portion_quantity = 4;
 * @return {?proto.google.protobuf.FloatValue}
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.getPortionQuantity = function() {
  return /** @type{?proto.google.protobuf.FloatValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.FloatValue, 4));
};


/**
 * @param {?proto.google.protobuf.FloatValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.NixFood} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.setPortionQuantity = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.NixFood} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.clearPortionQuantity = function() {
  return this.setPortionQuantity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.hasPortionQuantity = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue portion_unit = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.getPortionUnit = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.NixFood} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.setPortionUnit = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.NixFood} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.clearPortionUnit = function() {
  return this.setPortionUnit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.hasPortionUnit = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue nutritionix_id = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.getNutritionixId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.NixFood} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.setNutritionixId = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.NixFood} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.clearNutritionixId = function() {
  return this.setNutritionixId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.hasNutritionixId = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.FloatValue cal_count = 7;
 * @return {?proto.google.protobuf.FloatValue}
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.getCalCount = function() {
  return /** @type{?proto.google.protobuf.FloatValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.FloatValue, 7));
};


/**
 * @param {?proto.google.protobuf.FloatValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.NixFood} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.setCalCount = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.NixFood} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.clearCalCount = function() {
  return this.setCalCount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.NixFood.prototype.hasCalCount = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodType.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.FoodType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodType.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodType}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.FoodType;
  return proto.com.livongo.protobuf.grpc.external.food.FoodType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodType}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.FoodType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodType.Values = {
  INVALID: 0,
  COMMON: 1,
  BRAND: 2,
  RECIPE: 3
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    startTime: (f = msg.getStartTime()) && livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.toObject(includeInstance, f),
    endTime: (f = msg.getEndTime()) && livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.toObject(includeInstance, f),
    count: (f = msg.getCount()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    offset: (f = msg.getOffset()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest;
  return proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp;
      reader.readMessage(value,livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.deserializeBinaryFromReader);
      msg.setStartTime(value);
      break;
    case 3:
      var value = new livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp;
      reader.readMessage(value,livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.deserializeBinaryFromReader);
      msg.setEndTime(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setCount(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setOffset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStartTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.serializeBinaryToWriter
    );
  }
  f = message.getCount();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getOffset();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional com.livongo.protobuf.common.types.AbsoluteTimestamp start_time = 2;
 * @return {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.getStartTime = function() {
  return /** @type{?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp, 2));
};


/**
 * @param {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.setStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.clearStartTime = function() {
  return this.setStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.hasStartTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional com.livongo.protobuf.common.types.AbsoluteTimestamp end_time = 3;
 * @return {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.getEndTime = function() {
  return /** @type{?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp, 3));
};


/**
 * @param {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.setEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.clearEndTime = function() {
  return this.setEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.hasEndTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Int32Value count = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.getCount = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.setCount = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.clearCount = function() {
  return this.setCount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.hasCount = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Int32Value offset = 5;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.getOffset = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 5));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.setOffset = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.clearOffset = function() {
  return this.setOffset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogHistoryRequest.prototype.hasOffset = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    foodLog: (f = msg.getFoodLog()) && proto.com.livongo.protobuf.grpc.external.food.FoodLog.toObject(includeInstance, f),
    tzOffset: (f = msg.getTzOffset()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    updateMask: (f = msg.getUpdateMask()) && google_protobuf_field_mask_pb.FieldMask.toObject(includeInstance, f),
    testOnlyFields: (f = msg.getTestOnlyFields()) && proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest;
  return proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.livongo.protobuf.grpc.external.food.FoodLog;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.FoodLog.deserializeBinaryFromReader);
      msg.setFoodLog(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setTzOffset(value);
      break;
    case 3:
      var value = new google_protobuf_field_mask_pb.FieldMask;
      reader.readMessage(value,google_protobuf_field_mask_pb.FieldMask.deserializeBinaryFromReader);
      msg.setUpdateMask(value);
      break;
    case 100:
      var value = new proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields.deserializeBinaryFromReader);
      msg.setTestOnlyFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFoodLog();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.com.livongo.protobuf.grpc.external.food.FoodLog.serializeBinaryToWriter
    );
  }
  f = message.getTzOffset();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getUpdateMask();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_field_mask_pb.FieldMask.serializeBinaryToWriter
    );
  }
  f = message.getTestOnlyFields();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeStamp: (f = msg.getTimeStamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields;
  return proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimeStamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeStamp();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp time_stamp = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields.prototype.getTimeStamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields.prototype.setTimeStamp = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields.prototype.clearTimeStamp = function() {
  return this.setTimeStamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields.prototype.hasTimeStamp = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FoodLog food_log = 1;
 * @return {?proto.com.livongo.protobuf.grpc.external.food.FoodLog}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.prototype.getFoodLog = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.food.FoodLog} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.FoodLog, 1));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.food.FoodLog|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.prototype.setFoodLog = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.prototype.clearFoodLog = function() {
  return this.setFoodLog(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.prototype.hasFoodLog = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Int32Value tz_offset = 2;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.prototype.getTzOffset = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.prototype.setTzOffset = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.prototype.clearTzOffset = function() {
  return this.setTzOffset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.prototype.hasTzOffset = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.FieldMask update_mask = 3;
 * @return {?proto.google.protobuf.FieldMask}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.prototype.getUpdateMask = function() {
  return /** @type{?proto.google.protobuf.FieldMask} */ (
    jspb.Message.getWrapperField(this, google_protobuf_field_mask_pb.FieldMask, 3));
};


/**
 * @param {?proto.google.protobuf.FieldMask|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.prototype.setUpdateMask = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.prototype.clearUpdateMask = function() {
  return this.setUpdateMask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.prototype.hasUpdateMask = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional TestOnlyFields test_only_fields = 100;
 * @return {?proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.prototype.getTestOnlyFields = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields, 100));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.TestOnlyFields|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.prototype.setTestOnlyFields = function(value) {
  return jspb.Message.setWrapperField(this, 100, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.prototype.clearTestOnlyFields = function() {
  return this.setTestOnlyFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFoodLogRequest.prototype.hasTestOnlyFields = function() {
  return jspb.Message.getField(this, 100) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.toObject = function(includeInstance, msg) {
  var f, obj = {
    parent: jspb.Message.getFieldWithDefault(msg, 1, ""),
    imageMeta: (f = msg.getImageMeta()) && livongo_protobuf_common_meta_image_pb.ImageMetadata.toObject(includeInstance, f),
    note: jspb.Message.getFieldWithDefault(msg, 3, ""),
    mealTag: jspb.Message.getFieldWithDefault(msg, 4, 0),
    tzOffset: (f = msg.getTzOffset()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    createTime: (f = msg.getCreateTime()) && livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.toObject(includeInstance, f),
    nixFood: (f = msg.getNixFood()) && proto.com.livongo.protobuf.grpc.external.food.NixFood.toObject(includeInstance, f),
    testOnlyFields: (f = msg.getTestOnlyFields()) && proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation;
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setParent(value);
      break;
    case 2:
      var value = new livongo_protobuf_common_meta_image_pb.ImageMetadata;
      reader.readMessage(value,livongo_protobuf_common_meta_image_pb.ImageMetadata.deserializeBinaryFromReader);
      msg.setImageMeta(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    case 4:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.food.MealTag.Values} */ (reader.readEnum());
      msg.setMealTag(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setTzOffset(value);
      break;
    case 6:
      var value = new livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp;
      reader.readMessage(value,livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.deserializeBinaryFromReader);
      msg.setCreateTime(value);
      break;
    case 7:
      var value = new proto.com.livongo.protobuf.grpc.external.food.NixFood;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.NixFood.deserializeBinaryFromReader);
      msg.setNixFood(value);
      break;
    case 100:
      var value = new proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields.deserializeBinaryFromReader);
      msg.setTestOnlyFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getImageMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      livongo_protobuf_common_meta_image_pb.ImageMetadata.serializeBinaryToWriter
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMealTag();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getTzOffset();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getCreateTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.serializeBinaryToWriter
    );
  }
  f = message.getNixFood();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.com.livongo.protobuf.grpc.external.food.NixFood.serializeBinaryToWriter
    );
  }
  f = message.getTestOnlyFields();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeStamp: (f = msg.getTimeStamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields;
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimeStamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeStamp();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp time_stamp = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields.prototype.getTimeStamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields.prototype.setTimeStamp = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields.prototype.clearTimeStamp = function() {
  return this.setTimeStamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields.prototype.hasTimeStamp = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string parent = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.getParent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.setParent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional com.livongo.protobuf.common.meta.ImageMetadata image_meta = 2;
 * @return {?proto.com.livongo.protobuf.common.meta.ImageMetadata}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.getImageMeta = function() {
  return /** @type{?proto.com.livongo.protobuf.common.meta.ImageMetadata} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_meta_image_pb.ImageMetadata, 2));
};


/**
 * @param {?proto.com.livongo.protobuf.common.meta.ImageMetadata|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.setImageMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.clearImageMeta = function() {
  return this.setImageMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.hasImageMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string note = 3;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional MealTag.Values meal_tag = 4;
 * @return {!proto.com.livongo.protobuf.grpc.external.food.MealTag.Values}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.getMealTag = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.food.MealTag.Values} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.MealTag.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.setMealTag = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional google.protobuf.Int32Value tz_offset = 5;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.getTzOffset = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 5));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.setTzOffset = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.clearTzOffset = function() {
  return this.setTzOffset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.hasTzOffset = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional com.livongo.protobuf.common.types.AbsoluteTimestamp create_time = 6;
 * @return {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.getCreateTime = function() {
  return /** @type{?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp, 6));
};


/**
 * @param {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.setCreateTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.clearCreateTime = function() {
  return this.setCreateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.hasCreateTime = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional NixFood nix_food = 7;
 * @return {?proto.com.livongo.protobuf.grpc.external.food.NixFood}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.getNixFood = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.food.NixFood} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.NixFood, 7));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.food.NixFood|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.setNixFood = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.clearNixFood = function() {
  return this.setNixFood(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.hasNixFood = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional TestOnlyFields test_only_fields = 100;
 * @return {?proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.getTestOnlyFields = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields, 100));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.TestOnlyFields|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.setTestOnlyFields = function(value) {
  return jspb.Message.setWrapperField(this, 100, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.clearTestOnlyFields = function() {
  return this.setTestOnlyFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCreation.prototype.hasTestOnlyFields = function() {
  return jspb.Message.getField(this, 100) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tzOffset: (f = msg.getTzOffset()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    testOnlyFields: (f = msg.getTestOnlyFields()) && proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest;
  return proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setTzOffset(value);
      break;
    case 100:
      var value = new proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields.deserializeBinaryFromReader);
      msg.setTestOnlyFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTzOffset();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getTestOnlyFields();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeStamp: (f = msg.getTimeStamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields;
  return proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimeStamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeStamp();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp time_stamp = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields.prototype.getTimeStamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields.prototype.setTimeStamp = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields.prototype.clearTimeStamp = function() {
  return this.setTimeStamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields.prototype.hasTimeStamp = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Int32Value tz_offset = 2;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.prototype.getTzOffset = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.prototype.setTzOffset = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.prototype.clearTzOffset = function() {
  return this.setTzOffset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.prototype.hasTzOffset = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional TestOnlyFields test_only_fields = 100;
 * @return {?proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.prototype.getTestOnlyFields = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields, 100));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.TestOnlyFields|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.prototype.setTestOnlyFields = function(value) {
  return jspb.Message.setWrapperField(this, 100, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.prototype.clearTestOnlyFields = function() {
  return this.setTestOnlyFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogRequest.prototype.hasTestOnlyFields = function() {
  return jspb.Message.getField(this, 100) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: (f = msg.getUserId()) && teladoc_protobuf_common_user_identity_userId_pb.UserId.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest;
  return proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new teladoc_protobuf_common_user_identity_userId_pb.UserId;
      reader.readMessage(value,teladoc_protobuf_common_user_identity_userId_pb.UserId.deserializeBinaryFromReader);
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      teladoc_protobuf_common_user_identity_userId_pb.UserId.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional com.teladoc.protobuf.common.user.identity.UserId user_id = 2;
 * @return {?proto.com.teladoc.protobuf.common.user.identity.UserId}
 */
proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest.prototype.getUserId = function() {
  return /** @type{?proto.com.teladoc.protobuf.common.user.identity.UserId} */ (
    jspb.Message.getWrapperField(this, teladoc_protobuf_common_user_identity_userId_pb.UserId, 2));
};


/**
 * @param {?proto.com.teladoc.protobuf.common.user.identity.UserId|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest.prototype.setUserId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest.prototype.clearUserId = function() {
  return this.setUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.GetExternalUserIdRequest.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    startTime: (f = msg.getStartTime()) && livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.toObject(includeInstance, f),
    byFrequency: (f = msg.getByFrequency()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    maxRecordCount: (f = msg.getMaxRecordCount()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest;
  return proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp;
      reader.readMessage(value,livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.deserializeBinaryFromReader);
      msg.setStartTime(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setByFrequency(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setMaxRecordCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStartTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.serializeBinaryToWriter
    );
  }
  f = message.getByFrequency();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxRecordCount();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional com.livongo.protobuf.common.types.AbsoluteTimestamp start_time = 2;
 * @return {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.prototype.getStartTime = function() {
  return /** @type{?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp, 2));
};


/**
 * @param {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.prototype.setStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.prototype.clearStartTime = function() {
  return this.setStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.prototype.hasStartTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.BoolValue by_frequency = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.prototype.getByFrequency = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.prototype.setByFrequency = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.prototype.clearByFrequency = function() {
  return this.setByFrequency(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.prototype.hasByFrequency = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Int32Value max_record_count = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.prototype.getMaxRecordCount = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.prototype.setMaxRecordCount = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.prototype.clearMaxRecordCount = function() {
  return this.setMaxRecordCount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsRequest.prototype.hasMaxRecordCount = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.RecentFood.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.RecentFood.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.RecentFood} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.RecentFood.toObject = function(includeInstance, msg) {
  var f, obj = {
    nixFood: (f = msg.getNixFood()) && proto.com.livongo.protobuf.grpc.external.food.NixFood.toObject(includeInstance, f),
    lastTime: (f = msg.getLastTime()) && livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.toObject(includeInstance, f),
    loggedTimes: (f = msg.getLoggedTimes()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.RecentFood}
 */
proto.com.livongo.protobuf.grpc.external.food.RecentFood.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.RecentFood;
  return proto.com.livongo.protobuf.grpc.external.food.RecentFood.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.RecentFood} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.RecentFood}
 */
proto.com.livongo.protobuf.grpc.external.food.RecentFood.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.livongo.protobuf.grpc.external.food.NixFood;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.NixFood.deserializeBinaryFromReader);
      msg.setNixFood(value);
      break;
    case 2:
      var value = new livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp;
      reader.readMessage(value,livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.deserializeBinaryFromReader);
      msg.setLastTime(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setLoggedTimes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.RecentFood.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.RecentFood.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.RecentFood} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.RecentFood.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNixFood();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.com.livongo.protobuf.grpc.external.food.NixFood.serializeBinaryToWriter
    );
  }
  f = message.getLastTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.serializeBinaryToWriter
    );
  }
  f = message.getLoggedTimes();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional NixFood nix_food = 1;
 * @return {?proto.com.livongo.protobuf.grpc.external.food.NixFood}
 */
proto.com.livongo.protobuf.grpc.external.food.RecentFood.prototype.getNixFood = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.food.NixFood} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.NixFood, 1));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.food.NixFood|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.RecentFood} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.RecentFood.prototype.setNixFood = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.RecentFood} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.RecentFood.prototype.clearNixFood = function() {
  return this.setNixFood(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.RecentFood.prototype.hasNixFood = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional com.livongo.protobuf.common.types.AbsoluteTimestamp last_time = 2;
 * @return {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp}
 */
proto.com.livongo.protobuf.grpc.external.food.RecentFood.prototype.getLastTime = function() {
  return /** @type{?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp, 2));
};


/**
 * @param {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.RecentFood} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.RecentFood.prototype.setLastTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.RecentFood} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.RecentFood.prototype.clearLastTime = function() {
  return this.setLastTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.RecentFood.prototype.hasLastTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Int32Value logged_times = 3;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.food.RecentFood.prototype.getLoggedTimes = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.RecentFood} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.RecentFood.prototype.setLoggedTimes = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.RecentFood} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.RecentFood.prototype.clearLoggedTimes = function() {
  return this.setLoggedTimes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.RecentFood.prototype.hasLoggedTimes = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    recentFoodsList: jspb.Message.toObjectList(msg.getRecentFoodsList(),
    proto.com.livongo.protobuf.grpc.external.food.RecentFood.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse;
  return proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.com.livongo.protobuf.grpc.external.food.RecentFood;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.RecentFood.deserializeBinaryFromReader);
      msg.addRecentFoods(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRecentFoodsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.com.livongo.protobuf.grpc.external.food.RecentFood.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated RecentFood recent_foods = 2;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.food.RecentFood>}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse.prototype.getRecentFoodsList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.food.RecentFood>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.RecentFood, 2));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.food.RecentFood>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse.prototype.setRecentFoodsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.RecentFood=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.food.RecentFood}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse.prototype.addRecentFoods = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.com.livongo.protobuf.grpc.external.food.RecentFood, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentFoodsResponse.prototype.clearRecentFoodsList = function() {
  return this.setRecentFoodsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest;
  return proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 id = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetFoodLogByIdRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest;
  return proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetFocusSetupVisibilityRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    visible: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility}
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility;
  return proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility}
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVisible(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVisible();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool visible = 2;
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility.prototype.getVisible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupVisibility.prototype.setVisible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    testOnlyFields: (f = msg.getTestOnlyFields()) && proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest;
  return proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 100:
      var value = new proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields.deserializeBinaryFromReader);
      msg.setTestOnlyFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTestOnlyFields();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields.toObject = function(includeInstance, msg) {
  var f, obj = {
    viewed: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields;
  return proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setViewed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getViewed();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool viewed = 1;
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields.prototype.getViewed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields.prototype.setViewed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional TestOnlyFields test_only_fields = 100;
 * @return {?proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.prototype.getTestOnlyFields = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields, 100));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.TestOnlyFields|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.prototype.setTestOnlyFields = function(value) {
  return jspb.Message.setWrapperField(this, 100, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.prototype.clearTestOnlyFields = function() {
  return this.setTestOnlyFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.UpdateFocusSetupViewStatusRequest.prototype.hasTestOnlyFields = function() {
  return jspb.Message.getField(this, 100) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    viewed: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus}
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus;
  return proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus}
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setViewed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getViewed();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool viewed = 2;
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus.prototype.getViewed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FocusSetupViewStatus.prototype.setViewed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    mealTag: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest;
  return proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.food.MealTag.Values} */ (reader.readEnum());
      msg.setMealTag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMealTag();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional MealTag.Values meal_tag = 2;
 * @return {!proto.com.livongo.protobuf.grpc.external.food.MealTag.Values}
 */
proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest.prototype.getMealTag = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.food.MealTag.Values} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.MealTag.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetRecentMealsByTagRequest.prototype.setMealTag = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.Meal.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.Meal} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.toObject = function(includeInstance, msg) {
  var f, obj = {
    mealId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    mealName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    frequency: (f = msg.getFrequency()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    mealTag: jspb.Message.getFieldWithDefault(msg, 4, 0),
    lastUpdateTime: (f = msg.getLastUpdateTime()) && livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.toObject(includeInstance, f),
    foodsList: jspb.Message.toObjectList(msg.getFoodsList(),
    proto.com.livongo.protobuf.grpc.external.food.NixFood.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.Meal}
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.Meal;
  return proto.com.livongo.protobuf.grpc.external.food.Meal.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.Meal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.Meal}
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMealId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMealName(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setFrequency(value);
      break;
    case 4:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.food.MealTag.Values} */ (reader.readEnum());
      msg.setMealTag(value);
      break;
    case 5:
      var value = new livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp;
      reader.readMessage(value,livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.deserializeBinaryFromReader);
      msg.setLastUpdateTime(value);
      break;
    case 6:
      var value = new proto.com.livongo.protobuf.grpc.external.food.NixFood;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.NixFood.deserializeBinaryFromReader);
      msg.addFoods(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.Meal.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.Meal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMealId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMealName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFrequency();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getMealTag();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getLastUpdateTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.serializeBinaryToWriter
    );
  }
  f = message.getFoodsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.com.livongo.protobuf.grpc.external.food.NixFood.serializeBinaryToWriter
    );
  }
};


/**
 * optional string meal_id = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.getMealId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.Meal} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.setMealId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string meal_name = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.getMealName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.Meal} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.setMealName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Int32Value frequency = 3;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.getFrequency = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.Meal} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.setFrequency = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.Meal} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.clearFrequency = function() {
  return this.setFrequency(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.hasFrequency = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional MealTag.Values meal_tag = 4;
 * @return {!proto.com.livongo.protobuf.grpc.external.food.MealTag.Values}
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.getMealTag = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.food.MealTag.Values} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.MealTag.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.Meal} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.setMealTag = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional com.livongo.protobuf.common.types.AbsoluteTimestamp last_update_time = 5;
 * @return {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp}
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.getLastUpdateTime = function() {
  return /** @type{?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp, 5));
};


/**
 * @param {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.Meal} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.setLastUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.Meal} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.clearLastUpdateTime = function() {
  return this.setLastUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.hasLastUpdateTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated NixFood foods = 6;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.food.NixFood>}
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.getFoodsList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.food.NixFood>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.NixFood, 6));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.food.NixFood>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.Meal} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.setFoodsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.NixFood=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.food.NixFood}
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.addFoods = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.com.livongo.protobuf.grpc.external.food.NixFood, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.Meal} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.Meal.prototype.clearFoodsList = function() {
  return this.setFoodsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    recentmealsList: jspb.Message.toObjectList(msg.getRecentmealsList(),
    proto.com.livongo.protobuf.grpc.external.food.Meal.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse;
  return proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.livongo.protobuf.grpc.external.food.Meal;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.Meal.deserializeBinaryFromReader);
      msg.addRecentmeals(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecentmealsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.livongo.protobuf.grpc.external.food.Meal.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Meal recentMeals = 1;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.food.Meal>}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse.prototype.getRecentmealsList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.food.Meal>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.Meal, 1));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.food.Meal>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse.prototype.setRecentmealsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.Meal=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.food.Meal}
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse.prototype.addRecentmeals = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.livongo.protobuf.grpc.external.food.Meal, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.ListRecentMealsResponse.prototype.clearRecentmealsList = function() {
  return this.setRecentmealsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    upsertmeal: (f = msg.getUpsertmeal()) && proto.com.livongo.protobuf.grpc.external.food.Meal.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest;
  return proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.com.livongo.protobuf.grpc.external.food.Meal;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.Meal.deserializeBinaryFromReader);
      msg.setUpsertmeal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpsertmeal();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.com.livongo.protobuf.grpc.external.food.Meal.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meal upsertMeal = 2;
 * @return {?proto.com.livongo.protobuf.grpc.external.food.Meal}
 */
proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest.prototype.getUpsertmeal = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.food.Meal} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.Meal, 2));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.food.Meal|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest.prototype.setUpsertmeal = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest.prototype.clearUpsertmeal = function() {
  return this.setUpsertmeal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.UpsertMealRequest.prototype.hasUpsertmeal = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.com.livongo.protobuf.grpc.external.food);
